<template>
  <section class="logic-args-dialog-wrapper">
    <template v-if="!argsId || Number(argsId) === 0">
      <span class="args-id-tag unbind">0 (未绑定)</span>
    </template>
    <template v-else-if="channelId !== argsId">
      <span class="args-id-tag disabled">{{ argsId }}</span>
    </template>
    <template v-else>
      <el-link type="primary" class="args-dialog-link" @click="handleDisplay">
        <font-awesome-icon :icon="buttonIcon"/> {{ argsId }}
      </el-link>
    </template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" append-to-body class="premium-dialog">
      <logic-args :owner-type="ownerType" :args-id="argsId" :logic-type="logicType"></logic-args>
    </el-dialog>
  </section>
</template>

<script>
import LogicArgs from '@/views/Xs/Args/LogicArgs.vue'

export default {
  name: 'XsLogicArgsDialog',
  components: { LogicArgs },
  props: {
    ownerType: {
      type: Number, // 0=channel, 1=game
      default: 0
    },
    argsId: {
      type: Number,
      default: 0
    },
    logicType: {
      type: Number, // 1=login, 2=pay
      default: 1
    },
    channelId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    dialogTitle () {
      const owner = this.ownerType === 1 ? '游戏' : '渠道'
      const type = this.logicType === 1 ? 'Login' : 'Pay'
      return `${type} Args - ${owner} ${this.channelId}`
    },
    buttonIcon () {
      return this.logicType === 1 ? 'fa-l' : 'fa-p'
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  mounted () {
  },
  methods: {
    handleDisplay () {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.logic-args-dialog-wrapper {
  display: inline-flex;
  align-items: center;
}

.args-id-tag {
  font-size: 11px;
  color: #475569;
  background: #F1F5F9;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  display: inline-block;
  letter-spacing: 0.2px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.args-id-tag.disabled {
  color: #94a3b8;
  background: #F8FAFC;
}

.args-id-tag.unbind {
  color: #94a3b8;
  background: #F8FAFC;
  border: 1px dashed #e2e8f0;
  font-weight: 500;
}

html.dark .args-id-tag {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.08);
}

html.dark .args-id-tag.disabled {
  color: #94a3b8;
  background: rgba(255, 255, 255, 0.05);
}

html.dark .args-id-tag.unbind {
  color: #64748b;
  background: rgba(15, 23, 42, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}

.args-dialog-link {
  font-weight: 600;
  font-size: 13px;
}

.args-dialog-link:hover {
  text-decoration: none !important;
}

/* 弹窗样式 */
.premium-dialog :deep(.el-dialog) {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}
</style>
